import { Input } from '@bancobarigui/barihaus';

interface DescriptionFieldProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
}

export function DescriptionField({
  value,
  onChange,
  label = 'Descrição',
  placeholder = 'Adicione uma descrição',
}: DescriptionFieldProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-600 mb-2">
        {label}
      </label>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
}
